import { call } from './actions/call';
import { entry } from './actions/entry';
import { list } from './actions/list';
import { menu } from './actions/menu';
import { playback } from './actions/playback';
import { postback } from './actions/postback';
import { queue } from './actions/queue';
import { time } from './actions/time';

export const worksheet = {
  status: {
    active: 'Aktif',
    draft: 'Tidak Aktif'
  },

  tooltips: {
    drag_and_drop: 'Pindahkan elemen skema yang diinginkan ke ruang kerja.'
  },

  modal: {
    remove: {
      content: `Anda yakin ingin menghapus skema <b>{name}<b>?`
    },

    remove_action: {
      content: `Anda yakin ingin menghapus pelayanan <b>{name}</b> pada skema?`
    },

    remove_relationship: {
      content: `Anda yakin ingin merubah koneksi link?`
    },

    create_relationship: {
      title: `Membuat Link`,
      content: 'Pilih kondisi penggabungan link'
    },

    action: {
      main: {
        button: {
          ok: '@:shared.component.button.save',
          cancel: '@:shared.component.button.cancel'
        }
      },

      child: {
        button: {
          ok: '@:shared.component.button.confirm',
          cancel: '@:shared.component.button.back'
        }
      }
    }
  },

  action: {
    type: {
      time: 'Waktu routing',
      queue: 'Queue',
      list: 'Daftar Nomor ',
      menu: 'Menu IVR Voice',
      playback: 'Playback',
      postback: 'Postback',
      url: 'URL',
      call: 'Call forwarding',
      entry: 'Entry point',
      start: 'Autoinformer',
      media: 'Pesan audio'
    },

    field: {
      name: {
        title: 'Judul'
      }
    },

    call,
    entry,
    list,
    menu,
    playback,
    postback,
    queue,
    time
  }
};
